import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import acknowledgmentReadModal from 'store/app/ui/modals/acknowledgment/read/action';
import currentChannel from 'store/selectors/currentChannel';

const mapStateToProps = state => ({
  channel: currentChannel(state),
});

const mapDispatchToProps = dispatch => ({
  actions: {
    acknowledgmentReadModal: bindActionCreators(acknowledgmentReadModal, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
